<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>Boleto {{ticket?.id}}</ion-title>
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/tecservice-transportec/tickets" color="primary"></ion-back-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding" *ngIf="ticket && ticket.id">
  <ion-card class="ticket">
    <ion-item lines="full">
      <ion-img class="photo" [src]="ticket.route_icon" slot="start" *ngIf="ticket.route_icon"></ion-img>
      <ion-label>
        <h3>{{ticket.route_name}}</h3>
        <p *ngIf="!ticket.method">Fecha: {{ticket.dotw | dayOfWeek}}</p>
        <p *ngIf="ticket.method">Fecha: {{ticket.date | toDatestring:'date'}}</p>
      </ion-label>
    </ion-item>
    <ion-row>
      <ion-col>
        <h3 *ngIf="!ticket.method">{{ticket.departure_time | slice:0:5}}</h3>
        <h3 *ngIf="ticket.method">{{ticket.starts_at | toDatestring:'H:mm'}}</h3>
        <p *ngIf="!ticket.type || ticket.type==='go'">{{ticket.stop_name}}</p>
        <p *ngIf="ticket.type==='return'">{{ticket.stop_name}}</p>
      </ion-col>
      <ion-col size="2">
        <h3>&nbsp;</h3>
        <ion-icon name="arrow-forward" color="primary"></ion-icon>
      </ion-col>
      <ion-col>
        <h3 *ngIf="ticket.amount"><span>{{ticket.amount | currency : 'USD' : 'symbol' : '1.0-0' }}</span></h3>
        <h3 *ngIf="!ticket.amount">
          <span *ngIf="!ticket.method || ticket.method === 'subscription'">Suscripción</span>
          <span *ngIf="ticket.method && ticket.method === 'swap'">Canje</span>
        </h3>
        <p *ngIf="!ticket.type || ticket.type==='go'">{{ticket.stop2_name}}</p>
        <p *ngIf="ticket.type==='return'">{{ticket.stop2_name}}</p>
      </ion-col>
    </ion-row>
  </ion-card>
  <ion-card class="qr" *ngIf="showQr">
    <qr-code [value]="qr" styleClass="aclass" [size]="qrSize" errorCorrectionLevel="L"></qr-code>
    <p *ngIf="!ticket.method || ticket.method === 'subscription'">ID: S{{("00000" + ticket.id).slice(-5) }}</p>
    <p *ngIf="ticket.method && ticket.method !== 'subscription'">ID: T{{("00000" + ticket.id).slice(-5) }}</p>
    <p>{{user?.fullname}}</p>
    <p>{{user?.enrollment}}</p>
  </ion-card>
  <ion-button
    (click)="onTrack(ticket)"
    shape="round"
    expand="block"
    *ngIf="ticket.realtrip_active && ticket.buses_gps?.length"
  >
    <ion-label>Track</ion-label>
    <ion-icon slot="end" src="/assets/icon/map-location.svg"></ion-icon>
  </ion-button>
  <ion-button shape="round" color="warning" expand="block" *ngIf="ticket.cancel_busticket" (click)="cancelTicket()">
    Cancelar boleto
  </ion-button>
</ion-content>
